import Script                from "next/script";
import { useEffect, useRef } from "react";

import { useSetAdBlockerDetected } from "_jotai/rooterPro";

function component ( { onAdFinish, onAdSkip } ) {
	const rewardRef            = useRef ( null );
	const setAdBlockerDetected = useSetAdBlockerDetected ();

	useEffect ( () => {
		const googletag = window.googletag || { cmd: [] };

		let rewardedSlot;

		googletag.cmd.push ( () => {
			try {
				rewardedSlot = googletag.defineOutOfPageSlot (
					// "/22639388115/rewarded_web_example",
					"/22991961619/rewarded_ads_web",
					googletag.enums.OutOfPageFormat.REWARDED
				);
			} catch ( error ) {
				// console.log ( "=============  error:", error );
			}

			// Slot returns null if the page or device does not support rewarded ads.
			if ( rewardedSlot ) {
				rewardedSlot.addService ( googletag.pubads () );

				googletag.pubads ().addEventListener ( "rewardedSlotReady", event => {
					// window.alert ( "Rewarded ad slot is ready." );

					// document.getElementById ( "watchAdButton" ).onclick = () => {
					event.makeRewardedVisible ();
					// window.alert ( "Rewarded ad is active." );

				} );

				googletag.pubads ().addEventListener ( "rewardedSlotClosed", () => {
					if ( rewardRef.current )
						onAdFinish ( rewardRef.current );
					else onAdSkip ();

					if ( rewardedSlot ) {
						googletag.destroySlots ( [ rewardedSlot ] );
					}
				} );

				googletag.pubads ().addEventListener ( "rewardedSlotGranted", event => {
					// rewardPayload     = event.payload;
					rewardRef.current = event.payload;
					// window.alert ( "Reward granted." );
				} );

				googletag.pubads ().addEventListener ( "slotRenderEnded", event => {
					if ( event.slot === rewardedSlot && event.isEmpty ) {
						// window.alert ( "No ad returned for rewarded ad slot." );
						onAdFinish ();
					}
				} );

				googletag.enableServices ();
				googletag.display ( rewardedSlot );
			} else {
				setAdBlockerDetected ( true );
				// window.alert ( "Rewarded ads are not supported in this browser." );
			}
		} );

	}, [] );

	return (
		<Script src = "//www.googletagservices.com/tag/js/gpt.js" />
	);
}
export default component;
